const validStatusesToReissue = ['expired', 'revoked', 'reissueNeeded'];
/**
 * Can Account Badge be Reissued?
 *
 * Only checks dealing with {@link AccountBadgeColumns}
 */
export function canAccountBadgeBeReissued(accountBadge) {
    if (!validStatusesToReissue.some((s) => s === accountBadge.columns.status)) {
        return { canReissue: false, errorMessage: 'Cannot reissue from current status' };
    }
    if (accountBadge.columns.statusReasonCanReissue === false) {
        return { canReissue: false, errorMessage: 'Cannot reissue, revoke reason does not allow it' };
    }
    if (accountBadge.columns.reissuedByAccountBadgeId) {
        return { canReissue: false, errorMessage: 'Cannot reissue, already was reissued' };
    }
    return { canReissue: true };
}
